var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 184,
    viewBox: "0 0 184 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6994_81264)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 90,
    r: 52,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 90,
    r: 51.5,
    stroke: "#1B9075"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6994_81264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.7497 70.7499C93.7497 70.2857 93.9341 69.8406 94.2623 69.5124C94.5905 69.1842 95.0356 68.9999 95.4997 68.9999C100.139 69.005 104.588 70.8503 107.868 74.1311C111.149 77.4119 112.995 81.8601 113 86.4999C113 86.964 112.815 87.4091 112.487 87.7373C112.159 88.0655 111.714 88.2499 111.25 88.2499C110.786 88.2499 110.34 88.0655 110.012 87.7373C109.684 87.4091 109.5 86.964 109.5 86.4999C109.496 82.7881 108.019 79.2296 105.395 76.605C102.77 73.9804 99.2114 72.504 95.4997 72.4999C95.0356 72.4999 94.5905 72.3155 94.2623 71.9873C93.9341 71.6591 93.7497 71.214 93.7497 70.7499ZM95.4997 79.4999C97.3562 79.4999 99.1367 80.2374 100.449 81.5501C101.762 82.8629 102.5 84.6434 102.5 86.4999C102.5 86.964 102.684 87.4091 103.012 87.7373C103.34 88.0655 103.786 88.2499 104.25 88.2499C104.714 88.2499 105.159 88.0655 105.487 87.7373C105.815 87.4091 106 86.964 106 86.4999C105.997 83.7159 104.89 81.0468 102.921 79.0783C100.953 77.1098 98.2836 76.0026 95.4997 75.9999C95.0356 75.9999 94.5905 76.1842 94.2623 76.5124C93.9341 76.8406 93.7497 77.2857 93.7497 77.7499C93.7497 78.214 93.9341 78.6591 94.2623 78.9873C94.5905 79.3155 95.0356 79.4999 95.4997 79.4999ZM111.412 98.2931C112.427 99.3101 112.996 100.688 112.996 102.124C112.996 103.56 112.427 104.938 111.412 105.955L109.82 107.79C95.4875 121.512 60.61 86.6434 74.12 72.2654L76.1325 70.5154C77.1506 69.5296 78.5159 68.9842 79.933 68.9973C81.3501 69.0104 82.705 69.5809 83.7047 70.5854C83.759 70.6396 87.0017 74.8519 87.0017 74.8519C87.9639 75.8627 88.4995 77.2055 88.4973 78.6011C88.495 79.9967 87.955 81.3377 86.9895 82.3454L84.963 84.8934C86.0844 87.6183 87.7333 90.0948 89.8148 92.1805C91.8964 94.2663 94.3695 95.9201 97.0922 97.0471L99.6559 95.0084C100.664 94.0436 102.005 93.5042 103.4 93.5023C104.795 93.5003 106.137 94.0359 107.148 94.9979C107.148 94.9979 111.358 98.2389 111.412 98.2931ZM109.004 100.838C109.004 100.838 104.817 97.6159 104.762 97.5616C104.402 97.2041 103.915 97.0036 103.407 97.0036C102.899 97.0036 102.412 97.2041 102.052 97.5616C102.004 97.6106 98.4747 100.423 98.4747 100.423C98.2368 100.612 97.9538 100.736 97.6533 100.783C97.3529 100.83 97.0455 100.797 96.7614 100.689C93.2343 99.3756 90.0305 97.3197 87.3672 94.6603C84.7038 92.0009 82.6432 88.8001 81.3247 85.2749C81.2078 84.9869 81.1697 84.673 81.2143 84.3655C81.2589 84.0579 81.3846 83.7678 81.5785 83.5249C81.5785 83.5249 84.3907 79.9934 84.438 79.9479C84.7954 79.5873 84.996 79.1002 84.996 78.5925C84.996 78.0848 84.7954 77.5976 84.438 77.2371C84.3837 77.1846 81.162 72.9934 81.162 72.9934C80.796 72.6653 80.3185 72.4895 79.8272 72.5022C79.3358 72.5149 78.868 72.7151 78.5195 73.0616L76.507 74.8116C66.6335 86.6836 96.8577 115.231 107.261 105.4L108.856 103.562C109.229 103.216 109.454 102.739 109.481 102.23C109.509 101.722 109.338 101.222 109.004 100.838Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6994_81264",
    x: 0,
    y: 0,
    width: 184,
    height: 184,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6994_81264"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6994_81264",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6994_81264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(71 69)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.91b9ad26ccaa48a92679a9e3f86f572b.svg";
export { ForwardRef as ReactComponent };